import { render, staticRenderFns } from "./SearchUserDialog.vue?vue&type=template&id=79cb25c2&scoped=true"
import script from "./SearchUserDialog.vue?vue&type=script&lang=ts"
export * from "./SearchUserDialog.vue?vue&type=script&lang=ts"
import style0 from "./SearchUserDialog.vue?vue&type=style&index=0&id=79cb25c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cb25c2",
  null
  
)

export default component.exports